const H = {
  name: "Table",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M5 22C3.34772 22 2 20.6523 2 19V5C2 3.34772 3.34772 2 5 2H19C20.6523 2 22 3.34772 22 5V19C22 20.6523 20.6523 22 19 22H5ZM4 5V8H8L8 4H5C4.45228 4 4 4.45228 4 5ZM8 10H4V14H8V10ZM10 14H20V10H10L10 14ZM8 16H4V19C4 19.5477 4.45228 20 5 20H8L8 16ZM10 20H19C19.5477 20 20 19.5477 20 19V16H10V20ZM10 4V8H20V5C20 4.45228 19.5477 4 19 4H10Z" fill="currentColor"/>
</svg>
  `
};
export {
  H as Table
};
